import React, { useState } from "react";
import AppBody from "../../components/AppBody";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  addAssignCourseToUser,
  getUserListForAssignCourse,
} from "../../../actions/course/assign_course/assign_course_action";
import DatePicker from "react-datepicker";

const AssignCourses = () => {
  const state = useSelector((state) => state.assignCourseReducer);
  const dispatch = useDispatch();
  const { slug } = useParams();
  const [selectedUsers, setSelectUser] = useState([]);

  const [assingCouese, setAssingCouese] = useState({
    start_date: new Date(),
    end_date: "",
    slug: slug,
  });

  useEffect(() => {
    dispatch(getUserListForAssignCourse());
  }, []);

  const addSelectOneUser = (id) => {
    if (!selectedUsers.includes(id)) {
      setSelectUser([...selectedUsers, id]);
    } else {
      setSelectUser(selectedUsers.filter((item) => item !== id));
    }
  };

  const addSelectAllUser = () => {
    setSelectUser([]);
    const arr = [];
    users.forEach(function (obj) {
      arr.push(obj.id);
    });
    setSelectUser(arr);
  };

  const removeSelectAllUser = () => {
    setSelectUser([]);
  };

  const addAssignCourse = () => {
    //console.log( {...assingCouese}+ "userID="+selectedUsers );
    dispatch(
      addAssignCourseToUser({ ...assingCouese, userIds: selectedUsers })
    );
  };
 const navigate=useNavigate();
  if(state.is_done) {
      navigate("/all-courses"); 
  }
  const users = state.userList;
  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="card w-100 border-0  shadow-xs p-0 mb-4">
            <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
              <Link to={"/all-courses"} className="d-inline-block mt-2">
                <i className="ti-arrow-left font-sm text-white"></i>
              </Link>
              <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                Assign Course To Users
              </h4>
            </div>
            <div className="card-body  p-4 w-100 border-0 ">
              <div className="row">
                <div className="col-lg-4 mb-2">
                  <div className="form-group">
                    <label className="mont-font fw-600 font-xsss">
                      Start Date & Time
                    </label>
                    <DatePicker
                      className="form-control"
                      selected={assingCouese.start_date}
                      readOnly={true}
                      minDate={new Date()}
                      onChange={(date) =>
                        setAssingCouese({ ...assingCouese, start_date: date })
                      }
                      showTimeSelect
                      dateFormat="P"
                    />
                    <span className="error-msg">
                      {state.errors ? state.errors.start_date : ""}
                    </span>
                  </div>
                </div>
                <div className="col-lg-4 mb-2">
                  <div className="form-group">
                    <label className="mont-font fw-600 font-xsss">
                      End Date & Time
                    </label>
                    <DatePicker
                      className="form-control"
                      selected={assingCouese.end_date}
                      minDate={assingCouese.start_date}
                      onChange={(date) =>
                        setAssingCouese({ ...assingCouese, end_date: date })
                      }
                      dateFormat="P"
                    />
                    <span className="error-msg">
                      {state.errors ? state.errors.end_date : ""}
                    </span>
                  </div>
                </div>
                <div className="col-lg-4 mb-12">
                  <div className="form-group">
                    <br />
                    <button
                      className="btn-common px-5 mr-t-12"
                      onClick={() => addAssignCourse()}
                    >
                      Assign Course
                    </button>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-4 mb-12">
                  <button
                    className="btn-common px-5"
                    onClick={() => addSelectAllUser()}
                  >
                    Select All
                  </button>
                  <button
                    className="btn-common px-5"
                    onClick={() => removeSelectAllUser()}
                  >
                    Remove All
                  </button>
                </div>
              </div>
              <br />
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Select User</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Email</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users &&
                      users.map((li, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>
                            <input
                              type="checkbox"
                              className="form-control assign-check"
                              value={li.id}
                              checked={
                                selectedUsers.includes(li.id) ? true : false
                              }
                              onChange={(e) => addSelectOneUser(li.id)}
                            />
                          </td>
                          <td>{li.first_name}</td>
                          <td>{li.last_name}</td>
                          <td>{li.email}</td>
                          {/*<a
                              className="line-height-36 custom-icon mr-2"
                              title="Update"
                              target="_blank"
                              onClick={() => updateUserProfile(li.slug)}
                            >
                              <i className="feather-edit"></i>
                            </a>*/}
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default AssignCourses;
